// /**
//  * Custom header VRM search — mirrors AutoFinder UK app proxy lookup.
//  * Triggers on Enter, search icon click, or arrow button.
//  */
// (function () {
//   const SEARCH_BOX_SELECTOR = '.kg-vrm-search-box';
//   const INPUT_SELECTOR = '.kg-vrm-search-box-input';
//   const ICON_SELECTOR = '.kg-vrm-search-box-icon';
//   const BUTTON_SELECTOR = '.kg-vrm-search-box-button';
//   const BUTTON_ARROW_SELECTOR = '.kg-vrm-search-box-button-arrow';
//   const BUTTON_SPINNER_SELECTOR = '.kg-vrm-search-box-button-spinner';
//   const LOOKUP_ENDPOINT = '/apps/vrm-lookup';
//   const REDIRECT_BEHAVIOR = 'all_products'; // match AutoFinder block default

//   function initKgVrmSearch() {
//     const searchBoxes = document.querySelectorAll(SEARCH_BOX_SELECTOR);
//     if (!searchBoxes.length) return;

//     searchBoxes.forEach((box) => {
//       if (box.dataset.kgVrmBound === 'true') return;
//       box.dataset.kgVrmBound = 'true';

//       const input = box.querySelector(INPUT_SELECTOR);
//       const icon = box.querySelector(ICON_SELECTOR);
//       const button = box.querySelector(BUTTON_SELECTOR);
//       if (!input) return;

//       const buttonArrow = button ? button.querySelector(BUTTON_ARROW_SELECTOR) : null;
//       const buttonSpinner = button ? button.querySelector(BUTTON_SPINNER_SELECTOR) : null;
//       const isMobileBar = Boolean(box.closest('.kg-vrm-mobile-bar'));

//       // Mobile bar sits in header stacking context — force focus on first tap
//       if (isMobileBar) {
//         const focusMobileInput = (event) => {
//           if (event.target.closest(BUTTON_SELECTOR) || event.target.closest(ICON_SELECTOR)) return;
//           if (document.activeElement !== input) {
//             input.focus({ preventScroll: true });
//           }
//         };
//         box.addEventListener('pointerdown', focusMobileInput);
//         input.addEventListener('pointerdown', (event) => {
//           event.stopPropagation();
//           input.focus({ preventScroll: true });
//         });
//       }

//       input.addEventListener('input', () => {
//         input.value = input.value.toUpperCase().replace(/\s+/g, '');
//         clearErrorState(box, button);
//       });

//       input.addEventListener('keydown', (event) => {
//         if (event.key === 'Enter') {
//           event.preventDefault();
//           lookupVrm(box, input, button, buttonArrow, buttonSpinner);
//         }
//       });

//       if (button) {
//         button.addEventListener('click', (event) => {
//           event.preventDefault();
//           lookupVrm(box, input, button, buttonArrow, buttonSpinner);
//         });
//       }

//       if (icon) {
//         icon.setAttribute('role', 'button');
//         icon.setAttribute('tabindex', '0');
//         icon.setAttribute('aria-label', 'Find vehicle');
//         icon.style.cursor = 'pointer';

//         icon.addEventListener('click', (event) => {
//           event.preventDefault();
//           lookupVrm(box, input, button, buttonArrow, buttonSpinner);
//         });

//         icon.addEventListener('keydown', (event) => {
//           if (event.key === 'Enter' || event.key === ' ') {
//             event.preventDefault();
//             lookupVrm(box, input, button, buttonArrow, buttonSpinner);
//           }
//         });
//       }
//     });
//   }

//   function clearErrorState(box, button) {
//     box.classList.remove('is-error');
//     if (button) button.classList.remove('result-error');
//   }

//   function setLoadingState(box, input, button, buttonArrow, buttonSpinner, isLoading) {
//     box.classList.toggle('is-loading', isLoading);
//     input.disabled = isLoading;
//     if (button) button.disabled = isLoading;
//     if (buttonArrow) buttonArrow.hidden = isLoading;
//     if (buttonSpinner) buttonSpinner.hidden = !isLoading;
//   }

//   function setErrorState(box, input, button, buttonArrow, buttonSpinner) {
//     box.classList.add('is-error');
//     box.classList.remove('is-loading');
//     input.disabled = false;
//     if (button) {
//       button.disabled = false;
//       button.classList.add('result-error');
//     }
//     if (buttonArrow) buttonArrow.hidden = false;
//     if (buttonSpinner) buttonSpinner.hidden = true;

//     const resetErrorState = () => {
//       clearErrorState(box, button);
//     };

//     window.setTimeout(resetErrorState, 1000);
//     input.addEventListener('input', resetErrorState, { once: true });
//   }

//   function validateVrm(value) {
//     return Boolean(value && value.trim().length > 0);
//   }

//   async function lookupVrm(box, input, button, buttonArrow, buttonSpinner) {
//     if (box.classList.contains('is-loading')) return;

//     const vrm = input.value.trim();
//     if (!validateVrm(vrm)) return;

//     setLoadingState(box, input, button, buttonArrow, buttonSpinner, true);

//     try {
//       const endpoint = `${LOOKUP_ENDPOINT}?registration=${encodeURIComponent(vrm)}`;
//       const response = await fetch(endpoint);
//       const data = await response.json();

//       if (response.ok && data.success !== false && data.make) {
//         localStorage.setItem(
//           'savedVehicleInfo',
//           JSON.stringify({
//             make: data.make,
//             model: data.model,
//             fullModel: data.fullModel || data.model,
//             year: data.year,
//             enginecc: data.enginecc !== undefined ? data.enginecc : null,
//             litres: data.litres !== undefined ? data.litres : null,
//             fuel: data.fuel !== undefined ? data.fuel : null,
//             vrm: vrm,
//             redirectUrl: data.redirectUrl,
//             showFullModelName:
//               data.showFullModelName !== undefined ? data.showFullModelName : true,
//           })
//         );

//         if (data.redirectUrl) {
//           redirectAfterLookup(vrm, data);
//           return;
//         }

//         setErrorState(box, input, button, buttonArrow, buttonSpinner);
//         return;
//       }

//       if (response.status === 400 || response.status === 404 || data.success === false) {
//         setErrorState(box, input, button, buttonArrow, buttonSpinner);
//         return;
//       }

//       throw new Error(data.message || 'Error looking up vehicle information');
//     } catch (error) {
//       setErrorState(box, input, button, buttonArrow, buttonSpinner);
//     } finally {
//       if (!box.classList.contains('is-error')) {
//         setLoadingState(box, input, button, buttonArrow, buttonSpinner, false);
//       }
//     }
//   }

//   function redirectAfterLookup(vrm, data) {
//     try {
//       if (REDIRECT_BEHAVIOR === 'current_collection' && window.location.pathname.includes('/collections/')) {
//         const currentCollectionMatch = window.location.pathname.match(/\/collections\/([^/]+)/);
//         if (currentCollectionMatch && currentCollectionMatch[1] && currentCollectionMatch[1] !== 'all') {
//           const currentCollectionUrl = new URL(window.location.pathname, window.location.origin);

//           if (data.tags && Array.isArray(data.tags)) {
//             data.tags.forEach((tag) => {
//               currentCollectionUrl.searchParams.append('filter.p.tag', tag);
//             });
//           }

//           currentCollectionUrl.searchParams.set('filter.v.availability', '1');
//           currentCollectionUrl.searchParams.set('sort_by', 'best-selling');
//           currentCollectionUrl.searchParams.set('vrm', vrm);
//           if (data.id) currentCollectionUrl.searchParams.set('id', data.id);

//           window.location.href = currentCollectionUrl.href;
//           return;
//         }
//       }

//       const finalUrl = new URL(data.redirectUrl, window.location.origin);
//       finalUrl.searchParams.set('vrm', vrm);
//       if (data.id) finalUrl.searchParams.set('id', data.id);
//       window.location.href = finalUrl.href;
//     } catch (urlError) {
//       throw urlError;
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initKgVrmSearch);
//   } else {
//     initKgVrmSearch();
//   }

//   document.addEventListener('shopify:section:load', initKgVrmSearch);
// })();


/**
 * Custom header VRM search — mirrors AutoFinder UK app proxy lookup.
 * Triggers on Enter, search icon click, or arrow button.
 */
(function () {
  const SEARCH_BOX_SELECTOR = '.kg-vrm-search-box';
  const INPUT_SELECTOR = '.kg-vrm-search-box-input';
  const ICON_SELECTOR = '.kg-vrm-search-box-icon';
  const BUTTON_SELECTOR = '.kg-vrm-search-box-button';
  const BUTTON_ARROW_SELECTOR = '.kg-vrm-search-box-button-arrow';
  const BUTTON_SPINNER_SELECTOR = '.kg-vrm-search-box-button-spinner';
  const LOOKUP_ENDPOINT = '/apps/vrm-lookup';
  const REDIRECT_BEHAVIOR = 'all_products'; // match AutoFinder block default

  function initKgVrmSearch() {
    const searchBoxes = document.querySelectorAll(SEARCH_BOX_SELECTOR);
    if (!searchBoxes.length) return;

    searchBoxes.forEach((box) => {
      if (box.dataset.kgVrmBound === 'true') return;
      box.dataset.kgVrmBound = 'true';

      const input = box.querySelector(INPUT_SELECTOR);
      const icon = box.querySelector(ICON_SELECTOR);
      const button = box.querySelector(BUTTON_SELECTOR);
      if (!input) return;

      const buttonArrow = button ? button.querySelector(BUTTON_ARROW_SELECTOR) : null;
      const buttonSpinner = button ? button.querySelector(BUTTON_SPINNER_SELECTOR) : null;
      const isMobileBar = Boolean(box.closest('.kg-vrm-mobile-bar'));

      // Mobile bar sits in header stacking context — force focus on first tap
      if (isMobileBar) {
        const focusMobileInput = (event) => {
          if (event.target.closest(BUTTON_SELECTOR) || event.target.closest(ICON_SELECTOR)) return;
          if (document.activeElement !== input) {
            input.focus({ preventScroll: true });
          }
        };
        box.addEventListener('pointerdown', focusMobileInput);
        input.addEventListener('pointerdown', (event) => {
          event.stopPropagation();
          input.focus({ preventScroll: true });
        });
      }

      input.addEventListener('input', () => {
        input.value = input.value.toUpperCase().replace(/\s+/g, '');
        clearErrorState(box, button);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          lookupVrm(box, input, button, buttonArrow, buttonSpinner);
        }
      });

      if (button) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          lookupVrm(box, input, button, buttonArrow, buttonSpinner);
        });
      }

      if (icon) {
        icon.setAttribute('role', 'button');
        icon.setAttribute('tabindex', '0');
        icon.setAttribute('aria-label', 'Find vehicle');
        icon.style.cursor = 'pointer';

        icon.addEventListener('click', (event) => {
          event.preventDefault();
          lookupVrm(box, input, button, buttonArrow, buttonSpinner);
        });

        icon.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            lookupVrm(box, input, button, buttonArrow, buttonSpinner);
          }
        });
      }
    });
  }

  function clearErrorState(box, button) {
    box.classList.remove('is-error');
    if (button) button.classList.remove('result-error');
  }

  function setLoadingState(box, input, button, buttonArrow, buttonSpinner, isLoading) {
    box.classList.toggle('is-loading', isLoading);
    input.disabled = isLoading;
    if (button) {
      button.disabled = isLoading;
      button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }
    // Swap arrow for spinner while lookup is running
    if (buttonArrow) buttonArrow.hidden = isLoading;
    if (buttonSpinner) buttonSpinner.hidden = !isLoading;
  }

  function setErrorState(box, input, button, buttonArrow, buttonSpinner) {
    box.classList.add('is-error');
    box.classList.remove('is-loading');
    input.disabled = false;
    if (button) {
      button.disabled = false;
      button.setAttribute('aria-busy', 'false');
      button.classList.add('result-error');
    }
    if (buttonArrow) buttonArrow.hidden = false;
    if (buttonSpinner) buttonSpinner.hidden = true;

    const resetErrorState = () => {
      clearErrorState(box, button);
    };

    window.setTimeout(resetErrorState, 1000);
    input.addEventListener('input', resetErrorState, { once: true });
  }

  function validateVrm(value) {
    return Boolean(value && value.trim().length > 0);
  }

  async function lookupVrm(box, input, button, buttonArrow, buttonSpinner) {
    if (box.classList.contains('is-loading')) return;

    const vrm = input.value.trim();
    if (!validateVrm(vrm)) return;

    setLoadingState(box, input, button, buttonArrow, buttonSpinner, true);

    try {
      const endpoint = `${LOOKUP_ENDPOINT}?registration=${encodeURIComponent(vrm)}`;
      const response = await fetch(endpoint);
      const data = await response.json();

      if (response.ok && data.success !== false && data.make) {
        localStorage.setItem(
          'savedVehicleInfo',
          JSON.stringify({
            make: data.make,
            model: data.model,
            fullModel: data.fullModel || data.model,
            year: data.year,
            enginecc: data.enginecc !== undefined ? data.enginecc : null,
            litres: data.litres !== undefined ? data.litres : null,
            fuel: data.fuel !== undefined ? data.fuel : null,
            vrm: vrm,
            redirectUrl: data.redirectUrl,
            showFullModelName:
              data.showFullModelName !== undefined ? data.showFullModelName : true,
          })
        );

        if (data.redirectUrl) {
          redirectAfterLookup(vrm, data);
          return;
        }

        setErrorState(box, input, button, buttonArrow, buttonSpinner);
        return;
      }

      if (response.status === 400 || response.status === 404 || data.success === false) {
        setErrorState(box, input, button, buttonArrow, buttonSpinner);
        return;
      }

      throw new Error(data.message || 'Error looking up vehicle information');
    } catch (error) {
      setErrorState(box, input, button, buttonArrow, buttonSpinner);
    } finally {
      if (!box.classList.contains('is-error')) {
        setLoadingState(box, input, button, buttonArrow, buttonSpinner, false);
      }
    }
  }

  function redirectAfterLookup(vrm, data) {
    try {
      if (REDIRECT_BEHAVIOR === 'current_collection' && window.location.pathname.includes('/collections/')) {
        const currentCollectionMatch = window.location.pathname.match(/\/collections\/([^/]+)/);
        if (currentCollectionMatch && currentCollectionMatch[1] && currentCollectionMatch[1] !== 'all') {
          const currentCollectionUrl = new URL(window.location.pathname, window.location.origin);

          if (data.tags && Array.isArray(data.tags)) {
            data.tags.forEach((tag) => {
              currentCollectionUrl.searchParams.append('filter.p.tag', tag);
            });
          }

          currentCollectionUrl.searchParams.set('filter.v.availability', '1');
          currentCollectionUrl.searchParams.set('sort_by', 'best-selling');
          currentCollectionUrl.searchParams.set('vrm', vrm);
          if (data.id) currentCollectionUrl.searchParams.set('id', data.id);

          window.location.href = currentCollectionUrl.href;
          return;
        }
      }

      const finalUrl = new URL(data.redirectUrl, window.location.origin);
      finalUrl.searchParams.set('vrm', vrm);
      if (data.id) finalUrl.searchParams.set('id', data.id);
      window.location.href = finalUrl.href;
    } catch (urlError) {
      throw urlError;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKgVrmSearch);
  } else {
    initKgVrmSearch();
  }

  document.addEventListener('shopify:section:load', initKgVrmSearch);
})();
